import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function OpeningHookSection() {
  return <section className="py-12 md:py-24 px-4 bg-cream-200 relative overflow-hidden" data-id="element-83">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCI+PHBhdGggZD0iTTIwIDBMMCAyMGwyMCAyMCAyMC0yMEwyMCAweiIgZmlsbD0iIzAwMCIgZmlsbC1vcGFjaXR5PSIuMSIvPjwvc3ZnPg==')]" data-id="element-84"></div>

      <div className="max-w-3xl mx-auto text-center relative z-10" data-id="element-85">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex justify-center mb-4 md:mb-8" data-id="element-86">
          <div className="p-4 rounded-full bg-forest-900/5 text-forest-800 border border-forest-800/20" data-id="element-87">
            <Clock size={32} strokeWidth={1.5} data-id="element-88" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-4 md:space-y-8" data-id="element-89">
          <p className="text-2xl md:text-3xl font-playfair leading-relaxed text-ink-900 italic" data-id="element-90">
            "Son las 2 de la mañana. Un dolor de estómago punzante o una migraña
            cegadora te despierta. Vas al botiquín y solo encuentras pastillas
            vencidas o químicos que ya no quieres meter en tu cuerpo."
          </p>

          <div className="w-24 h-px bg-amber-500/40 mx-auto my-6 md:my-12" data-id="element-91"></div>

          <p className="text-lg md:text-xl font-lora text-ink-800 leading-relaxed max-w-2xl mx-auto" data-id="element-92">
            La solución no está en la farmacia de la esquina, sino a tres metros
            de tu cama:{' '}
            <strong className="text-forest-800 font-semibold" data-id="element-93">
              en tu propia alacena.
            </strong>{' '}
            Pero no se trata de hacer un "té común", se trata de activar la
            química oculta de tus alimentos.
          </p>
        </motion.div>
      </div>
    </section>;
}